/**
 * 跟时间相关的系列函数
 */

const getCurrentTimestamp = {
    fn: () => +new Date(),
    desc: '不需要参数，返回当前时间戳数值',
};

const getCurrentOffsetTimestamp = {
    fn: (val, offset = 0) => +new Date() + offset,
    desc: '需要两个参数(val, offset)，无视val并返回当前时间戳加上offset的值',
};

export default {
    getCurrentTimestamp,
    getCurrentOffsetTimestamp,
};
